export default __webpack_public_path__ + "static/media/calendar.eb4672f1.svg";